import React, { memo, useContext, useEffect, useState } from 'react'

import { InputField, InputLocalization, Modal } from '../../../components/common'
import { LanguageContext } from '../../../context/LanguageContext'
import { util } from '../../../util'

const CreatePushNotification = ({
    close,
    notification_loading,
    user,
    createPushNotification,
    modalOpen,
    modalClose,
}) => {
    const { customerWebLanguages, strings } = useContext(LanguageContext)

    const maxCharLimit = 65
    const [notificationName, setNotificationName] = useState('')
    const [localizations, setLocalizations] = useState({ localizations: {} })

    useEffect(() => {
        modalClose && close()
        return () => modalOpen()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalClose])

    /** Function to change the State of the notification name and character count.
     *
     * @param e - event object to track the value entered
     */
    const changeHandler = e => {
        setNotificationName(e.target.value)
    }

    /**
     * Function to post newly created notification, if success then navigates to notification details pages.
     */
    const saveClickHandler = () => {
        const formattedNotificationName = util.regexString(notificationName)
        createPushNotification({
            title: formattedNotificationName,
            localizations: localizations.localizations,
            created_by: user.email,
        })
    }

    const header = (
        <Modal.Heading heading={strings.createNotificationHeading} cancelModalHandler={close} />
    )

    const content = (
        <div className={'content'} data-testid={'modal_content'}>
            <InputField
                label={strings.TITLE}
                value={notificationName}
                onChange={changeHandler}
                type={'text'}
                size={'xl'}
                placeholder={strings.SECTION_CREATE_NEW_PUSH_NOTIFICATION}
                required
                name={'create push notification'}
                maxLength={maxCharLimit}
                showInputCount={true}
            />
            <div className={'edit-title-modal__input-localizations'}>
                <InputLocalization
                    fieldKey={'title'}
                    languages={customerWebLanguages.languages}
                    localizations={localizations.localizations}
                    setState={setLocalizations}
                    languageSection={({ label, onChange, value }) => (
                        <InputField
                            className={'input-localizations__field'}
                            isFullWidth
                            size={'xl'}
                            showInputCount={true}
                            maxLength={maxCharLimit}
                            type={'text'}
                            label={label}
                            placeholder={strings.SECTION_CREATE_NEW_PUSH_NOTIFICATION}
                            value={value}
                            onChange={onChange}
                        />
                    )}
                />
            </div>
        </div>
    )

    const modalActions = (
        <Modal.Actions
            color={notificationName.trim() && notificationName.length ? 'primary' : 'disabled'}
            cancelModalHandler={close}
            saveClickHandler={saveClickHandler}
            submitBtn={strings.SAVE}
            cancelBtn={strings.CANCEL}
            disabledBtn={!notificationName.trim().length || false}
            size={'xl'}
        />
    )

    return (
        <Modal
            size={'md'}
            header={header}
            content={content}
            actions={modalActions}
            loading={notification_loading}
        />
    )
}

export default memo(CreatePushNotification)
